<template>
  <div class="container_message">
    <MessageTypeLeft ref="messageTypeLeftRef" />
    <MessageListRight ref="messageListRightRef" />
  </div>
</template>

<script>
import MessageTypeLeft from "./children/messageTypeLeft.vue";
import MessageListRight from "./children/messageListRight.vue";
export default {
  components: { MessageTypeLeft, MessageListRight },
  provide() {
    return {
      messageRecordPro: this,
    };
  },
};
</script>

<style scoped lang='less'>
.container_message {
  display: flex;
  padding: 20px;
}
</style>